/**
 * Filters items whose representative map point falls inside padded Leaflet bounds.
 */
export function filterByViewportBounds<T>(
  items: T[],
  map: { getBounds?: () => any } | null | undefined,
  pad: number,
  getRepresentativeLatLng: (item: T) => unknown | null,
): T[] {
  if (!items?.length || !map?.getBounds) {
    return items ?? [];
  }

  try {
    const raw = map.getBounds();
    if (raw?.isValid && !raw.isValid()) {
      return items;
    }

    const bounds = typeof raw.pad === 'function' ? raw.pad(pad) : raw;

    const out: T[] = [];
    for (const item of items) {
      const ll = getRepresentativeLatLng(item);
      if (ll && bounds.contains(ll)) {
        out.push(item);
      }
    }
    return out;
  } catch {
    return items;
  }
}
